import type { Ref } from 'vue'
import type {
    RingBuilderResolveInput,
    RingBuilderResolveMode,
    RingSizeInput,
} from '@/graphql/api'
import { getCommissionJunctionInput } from '@/helpers/commission-junction'
import { getUri } from '@/helpers/getCurrentUri'
import { useRegionPlugin } from '@/plugins/region'

import { useCurrencyInput } from '@/plugins/currency-input.ts'
import { logUnexpectedError } from '@/helpers'

export function useEngagementRingGetInput(
    centreStoneUri: Readonly<Ref<string | null>>,
    engraving: Readonly<Ref<string>>,
    handleRingSizeNotSelected: () => RingSizeInput | null
): {
    getInput: (mode: RingBuilderResolveMode) => RingBuilderResolveInput | null
} {
    const { regionCode } = useRegionPlugin()
    const currency = useCurrencyInput()
    const commissionJunction = getCommissionJunctionInput()

    const getInput = (
        mode: RingBuilderResolveMode
    ): RingBuilderResolveInput | null => {
        const uri = getUri()
        const ringSize = handleRingSizeNotSelected()

        if (!ringSize) {
            return null
        }

        if (!uri || !centreStoneUri.value) {
            logUnexpectedError('Could not get input', {
                uri,
                centreStoneUri: centreStoneUri.value,
            })

            return null
        }

        return {
            mode,
            centreStoneUri: centreStoneUri.value,
            commissionJunction,
            currency: currency.value,
            engraving: engraving.value,
            region: regionCode.value,
            ringSize,
            uri,
        }
    }

    return {
        getInput,
    }
}
